import { COLUMN_NAME, COLUMN_SITE, COLUMN_TYPE, COLUMN_UNIQUE_IDENTIFIER } from "@/constants/column-types";
import { TableColumn } from "../table/TableColumn";
import { FILTER_SITES } from "@/constants/filter-types";

const OssDeviceColumns: TableColumn[] = [
    {
        heading: "Name",
        accessor: "name",
        isNumeric: false,
        id: 0,
        sortByName: "ossdName",
        sortDirection: "asc",
        active: true,
        translationKey: "name",
        isDefault: true,
        columnId: COLUMN_NAME,
    },
    {
        heading: "Type",
        accessor: "typeLabel",
        isNumeric: false,
        id: 1,
        active: true,
        translationKey: "type",
        columnId: COLUMN_TYPE,
    },
    {
        heading: "Door Id / Door Group Id",
        accessor: "ossdDeviceId",
        isNumeric: false,
        id: 2,
        sortByName: "ossdDeviceId",
        sortDirection: "asc",
        active: true,
        translationKey: "ossDoorIdOrGroupId",
        columnId: COLUMN_UNIQUE_IDENTIFIER,
    },
    {
        heading: "Site",
        accessor: "site",
        isNumeric: false,
        id: 3,
        sortByName: "site.siteName",
        sortDirection: "asc",
        active: true,
        searchOnName: "site.id",
        lookupName: "site.siteName",
        translationKey: "site",
        filterId: FILTER_SITES,
        columnId: COLUMN_SITE,
        settingDataName: "site",
    },
];

export default OssDeviceColumns;
